import {MainRequest, Status} from 'Services/common';
import {PlansType} from '../../Plans/PlansAll/service';
import {download, traverseTree} from '../../../Utils/common';
import {LevelType, ServiceData} from '../../Service/ServiceAll/service';
import {isEmpty} from '../../../Stores/commonStore';
import {IconType} from '../../../Utils/publicEnum';

/**
 * 用户列表(分页)
 */
export interface TenantList extends PaginationAntD {
    expirationEndTime: string;
    status: string;
    name: string;
}
export function getTenantPage(params?: TenantList) {
    return MainRequest.post<SuccessData<GetTenant[]>>('/customer/list', {
        ...params,
        pageNo: params?.current,
        pageSize: params?.pageSize,
    })
        .then(res => res.data.data)
        .then(res => {
            return {
                total: res.length,
                data: res,
            };
        });
}

export function getTenantOptions() {
    return MainRequest.post<SuccessData<GetTenant[]>>('/customer/list')
        .then(res => res.data.data)
        .then(res => {
            return res.map(item => {
                return {
                    value: item.code,
                    label: item.name,
                };
            });
        });
}

//保存租户
export enum TenantType {
    SaaS = '1',
    Private = '2',
}
export interface SaveTenant {
    id?: string; // id;
    serviceSubject: string; // '服务主体';
    name: string; // '服务名称';
    code: string; // '主体域名';
    location: string; // '110105';
    locationDetail: string; // '北京朝阳某某某';
    email: string; // 'xxxx@xx.com';
    phone: string;
    contacts: string;
    nameShort: string; //简称
    type: TenantType; //简称
}
export interface GetTenant extends SaveTenant {
    serviceVersionName: string;
    createTime: string;
    expirationEndTime: string; //到期时间
    appSecret: string;
    appSalt: string;
    token: string; //令牌
    subjectDomainName: string;
    appKey: string; //密钥
    status2: Status; //停用启用;
}
export function saveTenant(data?: SaveTenant) {
    return MainRequest.post<SuccessData<string>>('/customer/save', data).then(
        res => res.data.data,
    );
}
export function getTenant(id?: string) {
    if (!id) {
        return Promise.resolve(undefined);
    }
    return MainRequest.post<SuccessData<GetTenant>>('/customer/detail', {
        id,
    }).then(res => res.data.data);
}

//数据库连接参数
export interface TenantDatabase {
    ip: string; //
    port: string; // 端口
    username: string; // 用户名
    password: string; // 密码
}
export function getTenantDatabase(customerId: string) {
    return MainRequest.post<SuccessData<TenantDatabase>>(
        '/customerDatabase/detail',
        {
            customerId,
        },
    ).then(res => res.data.data);
}
//用户登录信息
export interface TenantLoginParams {
    loginName: string;
    pwd: string;
    subjectDomainName: string;
}
export function getTenantLoginParams(customerId: string) {
    return MainRequest.post<SuccessData<TenantLoginParams>>(
        'customer/getCustomerInfo',
        {
            customerId,
        },
    ).then(res => res.data.data);
}

//保存机构信息-模板
export interface ThemeForm {
    themeColor: string;
    fontColor: string;
    subjectLogo: string;
    backgroundImage: string;
}
export interface SaveTenantThemeProp {
    customerId: string;
    themeId: string;
    paramValue: ThemeForm;
}
export function saveTenantTheme(data: SaveTenantThemeProp) {
    return MainRequest.post('/customerTheme/save', data).then(
        res => res.data.data,
    );
}

//获取机构信息-模板
export interface TenantTheme {
    paramValue: string | ThemeForm;
    themeId: string;
}
export function getTenantTheme(customerId: string) {
    return MainRequest.post<SuccessData<TenantTheme>>(
        '/customerTheme/detail2',
        {
            customerId,
        },
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                paramValue:
                    typeof res.paramValue === 'string'
                        ? (JSON.parse(res.paramValue) as ThemeForm)
                        : res.paramValue,
                themeId: res.themeId,
            };
        });
}

//保存机构信息-登录
export interface SaveTenantLoginProp {
    customerId: string; // '1';
    backgroundImage: string; // '背景图url';
    signInStatus: string; // '注册状态';
    manualLoginCheck: string; // '注册审核';
    signInType: string; // '注册方式';
    serviceAgreement: string; // '服务协议';
    agreementTitle: string; // '协议标题';
    agreementContent: string; // '协议内容';
    privacyPolicy: string; // '隐私条款';
    privacyPolicyTitle: string; // '条款标题';
    privacyPolicyContent: string; // '隐私内容';
}
export function saveTenantLogin(data: SaveTenantLoginProp) {
    return MainRequest.post('/customerLoginSetting/save', data).then(
        res => res.data.data,
    );
}

//获取机构信息-登录
export function getTenantLogin(customerId: string) {
    return MainRequest.post<SuccessData<SaveTenantLoginProp>>(
        '/customerLoginSetting/detail',
        {
            customerId,
        },
    ).then(res => res.data.data);
}

//服务列表
interface ServiceList {
    code: string;
    id: string;
    name: string;
    expirationStartTime: string;
    expirationEndTime: string;
    maxUserNumber: string;
}
interface ServiceProps {
    otherList: ServiceList[];
    orderList: ServiceList[];
}
export function getTenantService(customerId: string) {
    return MainRequest.post<SuccessData<ServiceProps>>(
        '/customerServiceVersion/orderList',
        {
            customerId,
        },
    ).then(res => res.data.data);
}

//修改密码
export function changePwd(customerId: string, pwd: string) {
    return MainRequest.post('/customer/changePwd', {
        customerId,
        pwd,
    });
}

//删除租户
export function deleteTenant(id: string) {
    return MainRequest.post('/customer/delete', {
        id,
    });
}

export interface TenantViewInfoProps {
    adminLoginName: string;
    appKey: string;
    appSalt: string;
    appSecret: string;
    code: string;
    contacts: string;
    createTime: string;
    createUser: string;
    email: string;
    expirationEndTime: string;
    id: string;
    locationDetail: string;
    maxUserNumber: string;
    name: string;
    phone: string;
    serviceSubject: string;
    signType: string;
    signInType: string;
    status: string;
    subjectDomainName: string;
    token: string;
    updateTime: string;
    userNumber: string;
    versionName: string;
    versionName2: string; //大数据方案名称
    status2: string; //大数据状态
    maxUserNumber2: string; //大数据用户数
}

export function getTenantViewInfo(id: string) {
    return MainRequest.post<SuccessData<TenantViewInfoProps>>(
        '/customer/viewInfo',
        {
            id,
        },
    ).then(res => res.data.data);
}

//购买记录
export interface ServiceHistoryList {
    code: string;
    createTime: string;
    createUser: string;
    customerId: string;
    expirationEndTime: string;
    expirationStartTime: string;
    id: string;
    maxUserNumber: string;
    name: string;
    orderNumber: string;
    serviceVersionId: string;
    status: string;
    type: string;
    updateTime: string;
    serviceList: ServiceList[];
    serviceStatus: string;
    expireType: string;
}
export interface getTenantServiceHistoryListProps extends PaginationAntD {
    customerId: string;
}
export function getTenantServiceHistoryList(
    data: getTenantServiceHistoryListProps,
) {
    return MainRequest.post<PagedSuccessData<ServiceHistoryList[]>>(
        '/customerServiceVersion/page',
        data,
    ).then(res => res.data.data);
}

//购买
export interface BuyServiceProps {
    customerId: string;
    serviceVersionId: string;
    expirationStartTime: string;
    expirationEndTime: string;
    maxUserNumber: string;
    id?: string;
}
export function buyService(data: BuyServiceProps) {
    const o = {
        ...data,
        maxUserNumber: data?.maxUserNumber?.toString(),
    };
    return MainRequest.post('/customerServiceVersion/save', o).then(
        res => res.data.data,
    );
}

export function getServiceDetail(id: string) {
    return MainRequest.post<SuccessData<BuyServiceProps>>(
        '/customerServiceVersion/detail',
        {id},
    ).then(res => res.data.data);
}

//服务方案字典
export interface ServiceVersionProps extends DictType {
    code: string;
    expireType: string;
    id: string;
    maxUserNumber: string;
    name: string;
    type: PlansType;
}

//启用停用
export function changeTenantStatus(id: string, status: Status) {
    return MainRequest.post('/customer/changeStatus', {
        id,
        status,
    });
}

//获取服务器uuid
export function getServerUuid(customerId: string) {
    return MainRequest.post('/customerLocalServer/detail', {
        customerId,
    }).then(res => res.data.data);
}
//保存服务器uuid
interface SaveServerUuid {
    serverUuid: string;
    customerId: string;
}
export function saveServerUuid(data: SaveServerUuid) {
    return MainRequest.post('/customerLocalServer/save', data);
}

//服务更多设置
interface SaveServerSetting {
    serviceDetailId: string;
    customerId: string;
    id?: string;
}
export interface ServiceMenuProps {
    code: string;
    serviceCode: string;
    sort: string;
    parentId: string;
    children: string;
    createTime: string;
    levelType: string;
    customerId: string;
    name: string;
    createUser: string;
    id: string;
    status: Status;
    manageShowType: BooleanValue;
    h5ShowType: string;
}
export interface ServiceSettingData {
    childNumber: string;
    code: string;
    serviceCode: string;
    description: string;
    updateTime: string;
    sort: string;
    parentId: string;
    children: ServiceMenuProps[];
    createTime: string;
    levelType: string;
    customerId: string;
    name: string;
    createUser: string;
    id: string;
    serviceDetailId: string;
    status: Status;
}
export function getCustomerServiceDetail(data: SaveServerSetting) {
    return MainRequest.post<SuccessData<ServiceSettingData>>(
        '/customerServiceDetail/getCustomerService',
        data,
    ).then(res => res.data.data);
}
export function getCustomerServiceMenu(data: SaveServerSetting) {
    return MainRequest.post<SuccessData<ServiceSettingData>>(
        '/customerServiceDetail/getCustomerService',
        data,
    )
        .then(res => res?.data?.data)
        .then(res => {
            traverseTree(res, (node: ServiceData) => {
                if (isEmpty(node?.children)) {
                    node.children = undefined;
                }
            });
            return res?.children;
        });
}

export async function getCustomerDirectoryOptions(data: SaveServerSetting) {
    const options = await getCustomerServiceMenu(data);
    return options?.filter(option => option.levelType === LevelType.Directory);
}

export interface ServiceSetting {
    serviceDetailId: string;
    customerId: string;
    id: string;
    levelType: string;
    serviceCode: string;
    name: string;
    status: Status;
    manageShowType: BooleanValue;
    h5ShowType: string;
    h5Icon: string;
    iconType: IconType;
    menuUrl: string;
    description: string;
}
export function saveCustomerServiceMenu(data: ServiceSetting) {
    return MainRequest.post('/customerServiceDetail/save', data);
}
export function saveCustomerService(data: ServiceSetting) {
    return MainRequest.post('/customerServiceDetail/saveDescription', data);
}
export function nodeMoveDown(id: string) {
    return MainRequest.post('/customerServiceDetail/nodeMoveDown', {id});
}
export function nodeMoveUp(id: string) {
    return MainRequest.post('/customerServiceDetail/nodeMoveUp', {id});
}

export function changeServiceStatus(id: string, status: Status) {
    return MainRequest.post('/customerServiceDetail/changeStatus', {
        id,
        status,
    });
}

/**
 * 打包下载配置相关信息
 */
export function createCustomerLicense(id: string) {
    return download('/customer/createCustomerLicense', {
        method: 'post',
        data: {id},
    });
}
